import { groupBy, orderBy, sumBy } from "lodash";
import PosicaoAtivoInternacional from "../../../models/posicaoAtivoInternacional";
import {
  MoedaInternacional,
  TipoOperacaoInternacional,
} from "../../../models/enum";

export interface TotalPorMoeda {
  moeda: MoedaInternacional;
  valorOriginal: number;
}

// Opção lançada (posição vendida) é obrigação, não bem: fica fora dos totais.
export function posicoesCompradas(
  posicoes: PosicaoAtivoInternacional[]
): PosicaoAtivoInternacional[] {
  return posicoes.filter(
    (p) => p.tipoOperacao !== TipoOperacaoInternacional.SELL
  );
}

// Documento antigo sem o total gravado: reconstrói por quantidade × PM.
const totalOriginal = (p: PosicaoAtivoInternacional) =>
  p.valorTotalOriginal ?? (p.quantidade ?? 0) * (p.custoMedioOriginal ?? 0);
const totalBRL = (p: PosicaoAtivoInternacional) =>
  p.valorTotalBRL ?? (p.quantidade ?? 0) * (p.custoMedioBRL ?? 0);

export function totalCustodiaBRL(
  posicoes: PosicaoAtivoInternacional[]
): number {
  return sumBy(posicoesCompradas(posicoes), totalBRL);
}

// Soma do custo de aquisição na moeda de origem, sem conversão: o número que
// o investidor confere com o statement da corretora.
export function totaisCustodiaPorMoeda(
  posicoes: PosicaoAtivoInternacional[]
): TotalPorMoeda[] {
  return orderBy(
    Object.entries(
      groupBy(
        posicoesCompradas(posicoes).filter((p) => !!p.moeda),
        (p) => p.moeda
      )
    ).map(([moeda, ps]) => ({
      moeda: moeda as MoedaInternacional,
      valorOriginal: sumBy(ps, totalOriginal),
    })),
    [(t) => t.moeda],
    ["asc"]
  );
}
